// extracted by mini-css-extract-plugin
export default {"AnalyticItem":"short-analytic-line-chart_AnalyticItem__oJZDh","TitleText":"short-analytic-line-chart_TitleText__SNGku"};